



















import Vue from "vue";
import BasicCardTemplate from "./BasicCardTemplate.vue";

export default Vue.extend({
  name: "UnreadChatCard",
  props: {
    unreadChatCount: { type: Number }
  },
  methods: {
    redirectToChat() {
      this.$router.push("/chat");
    }
  }
});
